module.exports = __webpack_public_path__ + "static/media/pucit.4d6ab318.png";